import React from 'react'

import { BarChart } from '@driftt/dds.reports'

import {
  NON_DATE_BAR_CHART_OPTIONS,
  NON_DATE_BAR_CHART_OPTIONS_OLD,
} from 'constants/meetings'
import useQueryConfig from 'hooks/useQueryConfig'
import { hasGates } from 'utils/access'

import { useMeetingOutcomes } from './useMeetingOutcomes.hook'

const MeetingOutcomesChart = ({ metric }) => {
  const { queryConfig } = useQueryConfig(metric)

  const { metric: data, isLoading } = useMeetingOutcomes(queryConfig)
  const hasMeetingPreQualification = hasGates('has_meeting_pre_qualification')
  return (
    <BarChart
      series={data ?? []}
      isLoading={isLoading}
      orientation="column"
      stacking="normal"
      options={
        hasMeetingPreQualification
          ? NON_DATE_BAR_CHART_OPTIONS
          : NON_DATE_BAR_CHART_OPTIONS_OLD
      }
      tooltipXValueFormat="TITLE_CASE"
    />
  )
}

export default MeetingOutcomesChart
